import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import HomeHeader from '../../components/common/HomeHeader';
import ConsultationHeader from '../../components/common/ConsultationHeader';
import RewardsHeader from '../../components/common/RewardsHeader';
import Footer from '../../components/common/Footer';
import HomeContainer from '../home/HomeContainer';
import ConsultationTabContainer from '../home/ConsultationTabContainer';
import AccountContainer from '../home/AccountContainer';
import PolicyPurchased from '../policy/PolicyPurchased';
import RewardsTabContainer from '../home/RewardsTabContainer';
import CitiesList from '../consultation/CitiesList';
import NotFoundPage from '../../components/home/NotFoundPage';
import InsureTabNavigator from '../policy/InsureTabNavigator';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #fbfafc;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
`;

const BodyContainer = styled.div`
  flex: 1;
  display: flex;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;

class HomeTabContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    const { authToken, loginState, history, dispatch, location } = this.props;
    const { pathname, search } = location;
    console.log(loginState);
    if (loginState === 'LOGGED_IN') {
      dispatch({
        type: 'SET_SHOW_NAVIGATOR',
        payload: true,
      });
      dispatch({
        type: 'DONT_SHOW_NAVIGATOR',
        payload: false,
      });
    } else {
      dispatch({
        type: 'SET_SHOW_NAVIGATOR',
        payload: false,
      });
      dispatch({
        type: 'DONT_SHOW_NAVIGATOR',
        payload: true,
      });
    }
    const params = new URLSearchParams(search);
    if (
      (pathname === '/home/policy-purchased' &&
        !params.get('auth') &&
        !authToken &&
        loginState !== 'LOGGED_IN') ||
      (pathname !== '/home/policy-purchased' &&
        (loginState !== 'LOGGED_IN' || !authToken))
    ) {
      history.push('/');
    }
  };

  initializePubnubForVideo = () => {
    this.channelGroup = `visit-usr-group-${this.props.userInfo.userId}`;
    this.chatClient.subscribeForVideo(this.channelGroup);
  };

  componentDidUpdate = (prevProps, prevState) => {
    let prevSessionId = null;
    if (prevProps.videoCallPayload && prevProps.videoCallPayload.sessionId) {
      prevSessionId = prevProps.videoCallPayload.sessionId;
    }
    if (this.props.video?.videoCallPayload?.sessionId !== prevSessionId) {
    }
  };

  componentWillUnmount = () => {
    if (this.chatClient) {
      // this.chatClient.unsubscribeForVideo(this.channelGroup);
    }
  };

  render() {
    const {
      dispatch,
      walletBalance,
      showFitCoins,
      sponsorLogo,
      showHubbleRewards,
    } = this.props;
    return (
      <OuterContainer>
        <Switch>
          <Route
            path="/home"
            exact
            render={(props) => (
              <HomeHeader
                balance={walletBalance ? walletBalance.toString() : '0'}
                showFitCoins={showFitCoins}
                sponsorLogo={sponsorLogo}
                dispatch={dispatch}
                {...props}
              />
            )}
          />
          <Route
            path="/home/insure"
            exact
            render={(props) => (
              <>
                <div id={'hide-header'}>
                  <HomeHeader
                    balance={walletBalance ? walletBalance.toString() : '0'}
                    showFitCoins={showFitCoins}
                    sponsorLogo={sponsorLogo}
                    {...props}
                  />
                </div>
              </>
            )}
          />
          <Route
            path="/home/rewards"
            exact
            render={(props) =>
              showHubbleRewards ? (
                <></>
              ) : (
                <>
                  <div id={'enlarged-header'}>
                    <HomeHeader
                      balance={walletBalance ? walletBalance.toString() : '0'}
                      showFitCoins={showFitCoins}
                      sponsorLogo={sponsorLogo}
                      {...props}
                    />
                  </div>
                  <div id={'small-header'}>
                    <RewardsHeader
                      balance={walletBalance ? walletBalance.toString() : '0'}
                      {...props}
                    />
                  </div>
                </>
              )
            }
          />
          <Route path="/home/consult" component={ConsultationHeader} />
          {/* <Route path="/home/account" /> */}
          <Route path="/home/sample" component={CitiesList} />
        </Switch>
        <BodyContainer>
          <Switch>
            <Route path="/home" exact component={HomeContainer} />
            <Route path="/home/policy-purchased" component={PolicyPurchased} />
            <Route path="/home/consult" component={ConsultationTabContainer} />
            <Route path="/home/account" component={AccountContainer} />
            <Route path="/home/rewards" component={RewardsTabContainer} />
            <Route path="/home/insure" component={InsureTabNavigator} />
            <Route path="*" component={NotFoundPage} />
          </Switch>
        </BodyContainer>
        <Footer />
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  walletBalance: state.user.walletBalance,
  userInfo: state.user,
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  showFitCoins: state.app.config.showFitCoins,
  sponsorLogo: state.app.config.sponsorLogo,
  showHubbleRewards: state.app.config.showHubbleRewards,
});

export default connect(mapStateToProps)(HomeTabContainer);
